import { ValidationErrors, setIn } from "final-form";
import { AnyObjectSchema, object, string } from "yup";

const WRONG_EMAIL = "Email address is not valid";
const EMAIL_REQUIRED = "Your email address is required";
const PASSWORD_LENGTH = "Password needs to be a minimum of 6 characters";
const ZIP_CODE_REQUIRED = "A zip code is required";
const ZIP_CODE_FORMAT = "Please enter a valid zip code format, e.g., 90210";
const ZIP_CODE_LENGTH = "Zip code cannot be longer than 5 numbers";
export const wrongEmailMsg = "Email address is not valid";
const emailRequiredMsg = "Your email address is required";
export const fieldRequiredMsg = "Required";
export const regexEnglishChars = /^([\x20-\x7E]+)$/;

export const ENGLISH_CHARS = /^([\x20-\x7E]+)$/;

export const loginSchema = object().shape({
  email: string().trim().email(WRONG_EMAIL).required(EMAIL_REQUIRED),
  password: string()
    .trim()
    .min(6, PASSWORD_LENGTH)
    .required("Your password is required"),
});

export const forgotPasswordSchema = object().shape({
  email: string().trim().email(WRONG_EMAIL).required(EMAIL_REQUIRED),
});

const signUpPartial = {
  firstName: string().required(fieldRequiredMsg).nullable(),
  lastName: string().required(fieldRequiredMsg).nullable(),
  email: string()
    .trim()
    .email(wrongEmailMsg)
    .matches(regexEnglishChars, {
      excludeEmptyString: true,
      message: wrongEmailMsg,
    })
    .required(emailRequiredMsg),
  password: string()
    .trim()
    .required("Please enter a password to use for your account"),
};

export const signupSchema = object().shape({ ...signUpPartial });

export const zipCodeSchema = object({
  zipCode: string()
    .trim()
    .max(5, ZIP_CODE_LENGTH)
    .matches(/\d{5}/, {
      message: ZIP_CODE_FORMAT,
    })
    .required(ZIP_CODE_REQUIRED)
    .nullable(),
});

/* https://gist.github.com/manzoorwanijk/5993a520f2ac7890c3b46f70f6818e0a */
export const validateWithYup =
  (schema: AnyObjectSchema) =>
  async (values: unknown): Promise<ValidationErrors | undefined> => {
    try {
      await schema.validate(values, { abortEarly: false });
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err: any) {
      const errors = err?.inner?.reduce(
        (
          formError: Record<string, unknown>,
          innerError: { path: string; message: string },
        ) => {
          return setIn(formError, innerError.path, innerError.message);
        },
        {},
      );
      return errors;
    }
  };

// async field-level validation memoization from the react-final-form docs
// this is needed or the validation will infinitely loop
// https://final-form.org/docs/react-final-form/examples
// https://codesandbox.io/s/wy7z7q5zx5
// eslint-disable-next-line @typescript-eslint/ban-types
export const asyncFieldLevelMemo = (fn: Function) => {
  let lastArg: string;
  // eslint-disable-next-line @typescript-eslint/ban-types
  let lastResult: Promise<Function>;
  return (arg: string) => {
    if (arg !== lastArg) {
      lastArg = arg;
      lastResult = fn(arg);
    }
    return lastResult;
  };
};
